module.exports = __webpack_public_path__ + "static/team-big-706489c4a1667d6b61140e1301a252ab.webp";